var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.729,
    height: 9.704,
    viewBox: "0 0 5.729 9.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M9.279,6.03l4.007,3.99a.864.864,0,0,1,0,1.222L9.279,15.231A.862.862,0,0,1,8.063,14.01l3.393-3.379L8.063,7.252A.862.862,0,0,1,9.279,6.03Z",
    transform: "translate(-7.809 -5.779)",
    fill: "#1b2737",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRightArrow);
export default __webpack_public_path__ + "static/media/BlueRightArrow.e3bd682d9c09b1938a5a2194325e5f15.svg";
export { ForwardRef as ReactComponent };